export const cleanText = (str) => {
  const noSpecialChars = str?.replace(/[^a-zA-Z0-9\- .]/g, "").toLowerCase();
  const changeSpace = noSpecialChars?.replace(/\s/g, "-");
  const cleanText = changeSpace?.replace("--", "-");
  return cleanText;
};
